import React, {
	memo,
	useCallback
} from 'react';
import PropTypes from 'prop-types';
import {
	Icon,
	List,
	Popup
} from 'semantic-ui-react';
import { log } from '../../services/utils';

const PasswordValidationInfoPopup = ( { password } ) => {
	const setColor = useCallback( regex => {
		if ( !password ) {
			return null;
		}

		return regex.test( password )
			? 'green'
			: 'red';
	}, [ password ] );

	const setIcon = useCallback( regex => {
		if ( !password ) {
			return 'circle outline';
		}

		return regex.test( password )
			? 'check circle outline'
			: 'times circle outline';
	}, [ password ] );

	return (
		<Popup
			flowing
			position="top center"
			positionFixed
			trigger={
				<Icon
					name="info circle"
					size="large"
				/>
			}
		>
			{ log( '-passwordValidationInfoPopup' ) }
			<Popup.Content>
				<List>
					<List.Content>
						<List.Item>
							<List.Icon
								color={ setColor( /^.{8,}$/ ) }
								name={ setIcon( /^.{8,}$/ ) }
							/>
              &nbsp;
              At least 8 characters in length
						</List.Item>
						<List.Item>
							<List.Icon
								color={ setColor( /(.*[A-Z]+.*)$/ ) }
								name={ setIcon( /(.*[A-Z]+.*)$/ ) }
							/>
              &nbsp;
              One uppercase letter
						</List.Item>
						<List.Item>
							<List.Icon
								color={ setColor( /(.*[a-z]+.*)$/ ) }
								name={ setIcon( /(.*[a-z]+.*)$/ ) }
							/>
              &nbsp;
              One lowercase letter
						</List.Item>
						<List.Item>
							<List.Icon
								color={ setColor( /(.*[0-9]+.*)$/ ) }
								name={ setIcon( /(.*[0-9]+.*)$/ ) }
							/>
              &nbsp;
              One numeric digit
						</List.Item>
						<List.Item>
							<List.Icon
								color={ setColor( /(.*[`~!@#$%^&*()_=+[\]{}\\|;:’“,<.>/?-]+.*)$/ ) }
								name={ setIcon( /(.*[`~!@#$%^&*()_=+[\]{}\\|;:’“,<.>/?-]+.*)$/ ) }
							/>
              &nbsp;
              One special character
						</List.Item>
					</List.Content>
				</List>
			</Popup.Content>
		</Popup>
	);
};

PasswordValidationInfoPopup.propTypes = { password: PropTypes.string.isRequired };

export default memo( PasswordValidationInfoPopup );
